import type { Item } from 'shared-types';

export const GOLF_ITEM_TYPE = 'golf';

type GolfPlayerIds = {
  firstName?: string;
  lastName?: string;
};

type GolfLineIds = {
  courseId?: string;
  startTime?: string;
  bookingTypeId?: string;
  resourceId?: string;
  players?: GolfPlayerIds[];
  golfReference?: string;
  golfReservationId?: string;
};

export const isGolfItem = (item: { type?: string }): boolean => item.type === GOLF_ITEM_TYPE;

const golfLineIds = (item: Item): GolfLineIds => (item.bookable?.ids ?? {}) as GolfLineIds;

export const golfCourseId = (item: Item): string | undefined => {
  const { courseId } = golfLineIds(item);

  return courseId ? String(courseId) : undefined;
};

export const golfPlayerNames = (item: Item): string[] =>
  (golfLineIds(item).players ?? [])
    .map((player) => `${player.firstName ?? ''} ${player.lastName ?? ''}`.trim())
    .filter((name) => name.length > 0);

export const golfPlayerCount = (item: Item): number => (golfLineIds(item).players ?? []).length;

export const golfReference = (item: Item): string | undefined =>
  golfLineIds(item).golfReference || undefined;

export const golfPerPlayerMinorUnits = (item: Item): number | undefined => {
  const [perPlayer] = item.bookable?.pricesPerNight ?? [];

  return typeof perPlayer === 'number' && perPlayer > 0 ? perPlayer : undefined;
};
